<template>
  <section
    :id="anchorName"
    :class="[
      contentToTailwindClasses({ backgroundColor, entryAnimation }),
      hasValue(backgroundColor)
        ? contentToResponsivePaddingClasses({
            top: spacingTop,
            bottom: spacingBottom,
          })
        : contentToResponsiveMarginClasses({
            top: spacingTop,
            bottom: spacingBottom,
          }),
    ]"
    class="section-component"
  >
    <ClientOnly v-if="disableContentSSR">
      <EditableArea
        :class="[
          {
            container: container,
            'no-container': !container,
          },
        ]"
        :content="main"
        :custom-view="SectionComponentArea"
      />
      <template #fallback>
        <LoadingElement class="aspect-video" />
      </template>
    </ClientOnly>
    <EditableArea
      v-else
      :class="[
        {
          container: container,
          'no-container': !container,
        },
      ]"
      :content="main"
      :custom-view="SectionComponentArea"
    />
  </section>
</template>
<script setup>
import {
  contentToResponsivePaddingClasses,
  contentToResponsiveMarginClasses,
  contentToTailwindClasses,
} from "~/utils/helper/tailwind";
import SectionComponentArea from "./SectionComponentArea";
import { hasValue } from "~/utils/helper/magnolia";
import { EditableArea } from "@magnolia/vue-editor";
import LoadingElement from "~/templates/elements/LoadingElement.vue";

const props = defineProps([
  "container",
  "main",
  "anchorName",
  "spacingBottom",
  "spacingTop",
  "backgroundColor",
  "spacing",
  "contentWidth",
  "disableContentSSR",
  "entryAnimation",
]);
</script>
<script>
import { EditableArea } from "@magnolia/vue-editor";
import { editableComponent } from "~/utils/mixins/editableComponent";

export default {
  name: "SectionComponent",
  components: {
    EditableArea,
  },
  mixins: [editableComponent],
  provide() {
    return {
      content: this.content,
      spacing: this.spacing,
      contentWidth: this.contentWidth,
    };
  },
};
</script>
